module.exports = __webpack_public_path__ + "static/media/arrow-thic.6a27922c.svg";